import { FPageBlock, FPageContainerBlock } from '../../mdl/f-page-block';
import { UIInputAdapter } from '../../ui/component/adapter';
import { UILabeled } from '../../ui/component/labeled';
import { UIList } from '../../ui/component/list';
import { UISelect } from '../../ui/component/select';
import { UICheckbox } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { uiSetPrefixedClass } from '../../ui/functions';
import { UIViewSpec } from '../../ui/view';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlock, EDBlockSpec } from '../block';
import { EDBlockContainer, EDButtonSpec } from '../editor';
import { $page_values } from './values';

//TODO: we can do better by inheriting from something similar to what we inherit for the container
export const ed_page_hsplit_block: EDBlockSpec<FPageBlock> = {
    key: 'hsplit',
    editor_block: class extends EDBlock {
        private _blocks: UIInputAdapter<FPageContainerBlock, EDBlock<{}>>;

        constructor(container: EDBlockContainer) {
            const wrap = new UISelect($page_values.block_wrap, { kind: 'k-subtle' });
            const align = new UISelect($page_values.split_align, { kind: 'k-subtle' });
            const reverse = new UICheckbox({ title: 'Reverse in mobile' });

            const blocks: UIInputAdapter<FPageContainerBlock, EDBlock<any>> = new UIInputAdapter(b => {
                const block = this.editor.makeBlock(b, this);
                block.classList.add('r-editor-child');
                return { view: block, input: block.form };
            });

            const properties = $el.DIV('l-form', [
                new UILabeled(wrap, { above: 'Width' }),
                new UILabeled(align, { above: 'Align' }),
                reverse,
            ]);

            const list = new UIList<UIViewSpec>(blocks, { classes: 'blk-hsplit b b-block' });

            super($form({ blocks, reverse, wrap, align }), container, 'Horizontal split', properties, list.ui_elem);
            this._blocks = blocks;

            $on(blocks, 'change', () => {
                this.editor.tree.update();
            });

            $on(wrap, 'value', v => {
                uiSetPrefixedClass(this, 'm-wrap', v);
            });

            $on(align, 'value', v => {
                uiSetPrefixedClass(this, 'm-align', v);
            });
        }

        getChildButtons(_block: EDBlock): EDButtonSpec[] {
            return [];
        }

        get children() {
            return this._blocks.views;
        }
    }
};
